import { take } from 'redux-saga/effects';

export default function* logSaga() {
  while (1) {
    const action = yield take('*');
    console.log(action.type, action);
  }
}
